<template>
  <div>
    <div v-for="(intent, intentIndex) in data.intent" :key="intentIndex">
      <div
        v-bind:class="[languageActiveId === intent.language ? '' : 'd-none']"
      >
        <template v-if="sentimentActiveReply == 1">
          <SentimentResponse
            :dataList="intent.neutralReply"
            :channelList="channelList"
            :flowActiveIds="flowActiveIds"
            :level="level"
            :mainIntent="data"
            v-on:onReloadFlowList="onReloadFlowList"
            v-on:updateIntent="updateIntent"
            v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
            v-on:openNextFlowListFromButton="openNextFlowListFromButton"
          />
        </template>
        <template v-if="sentimentActiveReply == 2">
          <SentimentResponse
            :dataList="intent.negativeReply"
            :channelList="channelList"
            :flowActiveIds="flowActiveIds"
            :level="level"
            :mainIntentId="intent.mainIntentId"
            v-on:updateIntent="updateIntent"
            v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
            v-on:openNextFlowListFromButton="openNextFlowListFromButton"
            v-on:onReloadFlowList="onReloadFlowList"
          />
        </template>

        <div class="mt-1  border-top mx-3 pt-2">
          <KeywordForm
            :keywordList="intent.keyword"
            :showAllList="showAllKeyword"
            :showKeywordLength="6"
            :containerCustomCss="containerCustomCss"
            :readOnly="true"
            v-on:setShowAllKeyword="setShowAllKeyword"
          />
        </div>
      </div>
    </div>

    <div class="mt-2 mx-3 border-top py-3 ">
      <SentimentFooter :channelList="channelList" :data="data" />
    </div>

    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import SentimentResponse from "@/views/pages/flow-builder/components/response-type/SentimentResponse";
import SentimentFooter from "@/views/pages/flow-builder/components/response-type/SentimentFooter";
import KeywordForm from "@/views/pages/flow-builder/components/sidebar/KeywordForm";
import ModalConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  props: {
    data: {
      required: true,
      type: Object
    },
    flowActiveIds: {
      required: true,
      type: Array
    },
    showAllKeyword: {
      required: true,
      type: Boolean
    },
    level: {
      required: true,
      type: Number
    },
    channelList: {
      required: true,
      type: Array
    },
    languageActiveId: {
      required: true,
      type: Number
    }
  },
  components: {
    SentimentResponse,
    SentimentFooter,
    KeywordForm,
    ModalConfirm,
    ModalAlert,
    ModalLoading
  },
  data() {
    return {
      responseId: null,
      sentimentActiveReply: 1,
      containerCustomCss: {
        height: "auto",
        overflow: "auto",
        padding: " 0px !important",
        "margin-bottom": "10px !important",
        "background-color": "transparent  !important",
        border: "0px  !important"
      },

      imgModals: null,
      msgModals: null,
      modalAlertShow: false,
      modalData: [],
      isSuccess: false,
      isDeleteFlowAction: false
    };
  },
  created: async function() {},
  methods: {
    updateIntent(data) {
      if (data) {
        this.$emit("updateIntent", data);
      } else {
        this.$emit("updateIntent", this.data);
      }
    },
    openNextFlowListFromButton(level, id) {
      this.$emit("openNextFlowListFromButton", level, id);
    },
    setShowAllKeyword() {
      this.$emit("setShowAllKeyword");
    },
    createOrUpdateChildIntent(item, mainIntent) {
      this.$emit("createOrUpdateChildIntent", item, mainIntent);
    },

    onReloadFlowList() {
      this.$emit("onReloadFlowList");
    }
  }
};
</script>

<style lang="scss" scoped>
.background-white {
  background-color: white;
}
</style>
